import { put } from "redux-saga/effects";
import { closeCategoriesMenu } from "../actions/menus.actions";

export function* closeCategoryMenuLogic() {
  yield put(closeCategoriesMenu());
}
